import { Component } from '@angular/core';

@Component({
  selector: 'help-panel',
  templateUrl: './help-panel.component.html'
})
export class HelpPanelComponent {}
